import React, { Component } from 'react';
import 'bulma/css/bulma.css';
import './App.css';

import Header from './layouts/Header';
import ArticleList from './components/articles/ArticleList';

const articles = [{
  title: 'Test',
  body: 'Body Test',
  date: (new Date()).toLocaleDateString(),
  author: {
    image: 'http://www.radfaces.com/images/avatars/skeeter-valentine.jpg',
  }
}];

class App extends Component {
  render() {
    return (
      <div className="container">
        <Header />
        <ArticleList articles={articles} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js